interface Options {
  crossorigin?: string;
}

export function loadScript(id: string, src: string, onLoad?: () => void, options?: Options) {
  if (typeof document !== 'undefined') {
    const element = document.getElementById(id);
    if (!element) {
      const script = document.createElement('script');
      script.id = id;
      script.src = src;
      if (options?.crossorigin) {
        script.crossOrigin = options.crossorigin;
      }
      if (onLoad) {
        script.onload = onLoad;
      }
      document.body.appendChild(script);
    } else {
      onLoad && onLoad();
    }
  }
}
